module.exports = __webpack_public_path__ + "img/watermark-blend.adff95b5.svg";